import React, { useRef } from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import {
  SYSTEM_TRACK_COUNT, // 台数（1~100）
  GATE_PASSAGES_STATUS_CODE, // ゲート予定ステータス
  SPOT_STATUS, // スポット利用ステータス
  SPOT_TIMES,
  USER_ROLES,
  LUGGAGE_TYPES,
  ONLY_EDIT_VEHICLE_NUMBER,
  REQUEST_PARAMS,
} from '../../utilities/constants';

import ReactDropDownCalender from '../ReactDropDownCalender';
//import RequireIcon from '../RequireIcon';

import {
  FormList,
  FormListItem,
  FormElement,
  Validation,
} from '../CommonFormComponents';
import { Tel } from '../Tel';
import { FieldTreePartnerCompanyDropdown } from '../dropdowns/single/FieldTreePartnerCompanyDropdown';
import { FieldTreeJobDropdown } from '../dropdowns/single/FieldTreeJob';
import { FieldTreeUserDropdown } from '../dropdowns/single/FieldTreeUser';
import { FieldContractorUserDropdown } from '../dropdowns/single/FieldContractorUser';
import { GateDropdown } from '../dropdowns/single/Gate';
import { CraneDropdown } from '../dropdowns/single/Crane';
import { GatePassageLatestRegistrationDropdown } from '../dropdowns/single/GatePassageLatestRegistration';
import { GatePassageSpotHistoryDropdown } from '../dropdowns/single/GatePassageSpotHistory';

import LocalStorageService from '../../services/utilities/LocalStorageService';

import { isPrimaryCompanyRoleId } from '../../utilities/roleUtility';
import { isTimeInsideLimit, formatHourMin } from '../../utilities/momentUtil';
import dialogLoader from '../../utilities/dialogLoader'; // ダイアログ
import { CraneUseLatestRegistrationDropdown } from '../dropdowns/single/CraneUseLatestRegistration';
import { GatePassageTrackerTelHistoryDropdown } from '../dropdowns/single/GatePassageTrackerTelHistoryDropdown';
import DropdownSelector from '../dropdowns/DropdownSelector';

import { ArrowDownIcon } from '../icons/ArrowDownIcon';
import { VehicleNumberDialog } from '../modals/VehicleNumberDialog';
import { AisleManagement } from '../dropdowns/single/AisleManagement';
import GatePassageService from '../../services/GatePassages';
import {
  isEditConcurrentErrorGate,
  isSpotFlag,
  isStatusAcceptGateFutral,
  trackCountOptions,
} from '../../utilities/gatePassageUtil';
import { RadioButtonIcon } from '../icons/RadioButtonIcon';
import { ErrorDialog } from '../dialogs/ErrorDialog';
import { FormInformationDialog } from '../FormInformationDialog';
import { messageUtility } from '../../utilities/messageUtility';
import SessionStorageService from '../../services/utilities/SessionStorageService';

/**
 * ゲート予定フォーム
 * @param roleId {int}
 * @param isEdit {bool} 編集・登録
 * @param isSpot {bool} スポット利用
 * @param isSpotToggle {bool} スポット業者切替フラグ
 * @param events {function} イベントハンドラ
 * @param errors {object}
 * @param workTime {object} 現場作業時間
 * @param viewOnlyFlag {int} 閲覧制限フラグ
 * @param values {object} フォーム入力値
 * @param useConstructionSiteCodeFlg {bool}
 * @param setRouteIn {function}
 * @param setRouteOut {function}
 * @param fieldId {int}
 */
export const GatePassageForm = ({
  roleId,
  isEdit,
  isSpot,
  isSpotToggle,
  values,
  errors,
  workTime,
  viewOnlyFlag,
  events,
  pulldownName,
  useConstructionSiteCodeFlg,
  useTrackerFlg,
  setRouteIn,
  setRouteOut,
  fieldId,
  limitTruckCount,
}) => {
  // console.log('GatePassages.jsx', 'GatePassageForm', pulldownName);

  const isUpdatingFlag = useRef(false);
  if (_.isEmpty(workTime)) {
    return false;
  }
  const workStartTime =
    workTime[SessionStorageService.getItem('work_hour_zone')].start;
  const workEndTime =
    workTime[SessionStorageService.getItem('work_hour_zone')].end;

  // 開始時間
  const startTime = () => {
    const start = moment(`${moment().format('YYYY/MM/DD')} ${workStartTime}`);
    const end = moment(`${moment().format('YYYY/MM/DD')} ${workEndTime}`);
    // 日またぎ
    if (end.isSameOrBefore(start)) {
      end.add(1, 'day');
    }

    let time = [];
    for (
      var target = start.clone();
      target.isBefore(end);
      target.add(15, 'minutes')
    ) {
      time.push(
        <option
          key={target.format('HH:mm:ss')}
          value={target.format('HH:mm:ss')}
          data-select={target.format('YYYY/MM/DD HH:mm:ss')}
        >
          {target.format('HH:mm')}
        </option>
      );
    }
    return time;
  };

  // 終了時間
  const endTime = () => {
    const start = moment(`${moment().format('YYYY/MM/DD')} ${workStartTime}`);
    const end = moment(`${moment().format('YYYY/MM/DD')} ${workEndTime}`);
    // 日またぎ
    if (end.isSameOrBefore(start)) {
      end.add(1, 'day');
    }
    start.add(15, 'minutes');

    let time = [];
    for (
      var target = start.clone();
      target.isSameOrBefore(end);
      target.add(15, 'minutes')
    ) {
      time.push(
        <option
          key={target.format('HH:mm:ss')}
          value={target.format('HH:mm:ss')}
          data-select={target.format('YYYY/MM/DD HH:mm:ss')}
        >
          {target.format('HH:mm')}
        </option>
      );
    }
    return time;
  };

  const handleVehicleNumberDialog = viewOnlyFlag => {
    dialogLoader.show(VehicleNumberDialog, {
      vehicleNumbers: values.vehicle_numbers,
      callback: {
        save: async data => {
          if (viewOnlyFlag) {
            if (isUpdatingFlag.current) {
              return;
            }
            isUpdatingFlag.current = true;
            const params = _.cloneDeep(values);
            params.editing_vehicle_numbers_flag = ONLY_EDIT_VEHICLE_NUMBER;
            params.vehicle_numbers = data;
            GatePassageService.update(fieldId, params.id, params).then(
              response => {
                if (!response.result) {
                  if (isEditConcurrentErrorGate(response)) {
                    dialogLoader.show(FormInformationDialog, {
                      title: messageUtility.getMessage('E-001-402'),
                      message: messageUtility.getMessage('E-001-436'),
                      onClose: () => {
                        window.location.reload();
                      },
                    });
                  } else {
                    dialogLoader.show(ErrorDialog, {
                      message: response.message,
                      callback: {
                        close: () => {
                          dialogLoader.close();
                        },
                      },
                    });
                  }
                } else {
                  events.form.set(
                    'lock_version',
                    _.get(response, 'data.entities.gate_passage.lock_version')
                  );
                }
              }
            );
            isUpdatingFlag.current = false;
          }
          dialogLoader.close();
          events.form.set('vehicle_numbers', data);
        },
        close: () => {
          dialogLoader.close();
        },
      },
    });
  };

  const systemTruckCount =
    isStatusAcceptGateFutral(values.gate_fleet_status) && isEdit
      ? trackCountOptions(limitTruckCount)
      : SYSTEM_TRACK_COUNT;

  const isAcceptWithFutral =
    isEdit &&
    useConstructionSiteCodeFlg &&
    isStatusAcceptGateFutral(values.gate_fleet_status);

  const hasLuggageTypeRadio = useConstructionSiteCodeFlg && !viewOnlyFlag;

  return (
    <div
      className='slide-view__body GatePassageForm'
      style={{ height: 'calc(100vh - 120px)' }}
    >
      <div className='main__table set-width-dropdown'>
        <FormList isSpace={true}>
          {(Number(roleId) === USER_ROLES.partner.id ||
            Number(roleId) === USER_ROLES.foreman.id) &&
            !isEdit && (
              <FormListItem>
                <span
                  id='open-modal-confirm-copy'
                  className='btn-text form-list__copy-btn'
                  onClick={() => events.dialog.copy()}
                >
                  前回登録した内容をコピー
                </span>
              </FormListItem>
            )}
          {isEdit && (
            <FormListItem label='受付No'>
              <FormElement>
                <input
                  type='text'
                  disabled={viewOnlyFlag || isEdit}
                  value={values.today_receipt_no}
                />
              </FormElement>
            </FormListItem>
          )}
          <FormListItem
            label='期間'
            isUseItemIcon={useConstructionSiteCodeFlg}
            itemIconLabel='連携項目'
            required={true}
          >
            {isEdit ? (
              <FormElement
                validate={errors.passage_date && errors.passage_date}
              >
                <div htmlFor='' className='input-date-range'>
                  <ReactDropDownCalender
                    disabled={viewOnlyFlag || isAcceptWithFutral}
                    onChange={date =>
                      events.form.calender('passage_date', date)
                    }
                    value={values.passage_date}
                  />
                </div>
              </FormElement>
            ) : (
              <FormElement
                validate={
                  (errors.passage_date_from || errors.passage_date_to) &&
                  (errors.passage_date_from || errors.passage_date_to)
                }
              >
                <div htmlFor='' className='input-date-range'>
                  <ReactDropDownCalender
                    name='passage_date_from'
                    onChange={date =>
                      events.form.calender('passage_date_from', date)
                    }
                    value={values.passage_date_from}
                  />
                  <span className='input-date-range__bar--select'>〜</span>
                  <ReactDropDownCalender
                    name='passage_date_to'
                    onChange={date =>
                      events.form.calender('passage_date_to', date)
                    }
                    value={values.passage_date_to}
                  />
                </div>
              </FormElement>
            )}
          </FormListItem>
          <SpotField
            isSpot={isSpot}
            values={values}
            events={events}
            errors={errors}
            viewOnlyFlag={viewOnlyFlag}
            useConstructionSiteCodeFlg={useConstructionSiteCodeFlg}
          />
          <CompanyField
            isSpot={isSpot}
            isSpotToggle={isSpotToggle}
            values={values}
            events={events}
            errors={errors}
            viewOnlyFlag={viewOnlyFlag}
            isEdit={isEdit}
            pulldownName={pulldownName}
            useConstructionSiteCodeFlg={useConstructionSiteCodeFlg}
          />
          {useConstructionSiteCodeFlg && (
            <React.Fragment>
              <FormListItem
                label='手配担当者連絡先'
                isUseItemIcon={useConstructionSiteCodeFlg}
                itemIconLabel='連携項目'
                required={true}
              >
                <Tel
                  value={values.foreman_user_tel}
                  readOnly={viewOnlyFlag}
                  handleOnChange={events.form.set}
                  setKey='foreman_user_tel'
                  error={errors.foreman_user_tel}
                  validate={() => events.form.validate('foreman_user_tel')}
                  info='この連絡先は、万博会場建築における車両管理をする目的で、万博システムに連携されます。本人に同意を得たうえでご入力ください。'
                />
              </FormListItem>
              <FormListItem
                label='入場ルート'
                isUseItemIcon={useConstructionSiteCodeFlg}
                itemIconLabel='連携項目'
                required={true}
              >
                <FormElement validate={errors.enter_gate_fleet_system_route_id}>
                  {viewOnlyFlag ||
                  isStatusAcceptGateFutral(values.gate_fleet_status) ? (
                    <React.Fragment>
                      {values.enter_gate_fleet_system_route_name}
                    </React.Fragment>
                  ) : (
                    <AisleManagement
                      label='ルートを選択'
                      selectorName='name'
                      api={params =>
                        GatePassageService.getGateFleetSysRoutes(fieldId, {
                          ...params,
                        })
                      }
                      selectedValues={
                        _.isNull(values.enter_gate_fleet_system_route_id)
                          ? ''
                          : String(values.enter_gate_fleet_system_route_id)
                      }
                      selectedName={
                        _.isNull(values.enter_gate_fleet_system_route_name)
                          ? ''
                          : values.enter_gate_fleet_system_route_name
                      }
                      apiSearchKey='name'
                      keyName='name'
                      valueName='id'
                      apiBindDataKey='gate_fleet_system_routes'
                      strictEqual={true}
                      reloadOptions={false}
                      dropdownSelectStyle={{ width: '238px' }}
                      validate={() =>
                        events.form.validate('enter_gate_fleet_system_route_id')
                      }
                      column={'enter_gate_fleet_system_route_id'}
                      onSelect={(name, id, value) => setRouteIn(id, value)}
                    />
                  )}
                </FormElement>
              </FormListItem>
              <FormListItem
                label='退場ルート'
                isUseItemIcon={useConstructionSiteCodeFlg}
                itemIconLabel='連携項目'
                required={true}
              >
                <FormElement validate={errors.exit_gate_fleet_system_route_id}>
                  {viewOnlyFlag ||
                  isStatusAcceptGateFutral(values.gate_fleet_status) ? (
                    <React.Fragment>
                      {values.exit_gate_fleet_system_route_name}
                    </React.Fragment>
                  ) : (
                    <AisleManagement
                      label='ルートを選択'
                      selectorName='name'
                      api={params =>
                        GatePassageService.getGateFleetSysRoutes(fieldId, {
                          ...params,
                        })
                      }
                      selectedValues={
                        _.isNull(values.exit_gate_fleet_system_route_id)
                          ? ''
                          : String(values.exit_gate_fleet_system_route_id)
                      }
                      selectedName={
                        _.isNull(values.exit_gate_fleet_system_route_name)
                          ? ''
                          : values.exit_gate_fleet_system_route_name
                      }
                      apiSearchKey='name'
                      keyName='name'
                      valueName='id'
                      apiBindDataKey='gate_fleet_system_routes'
                      strictEqual={true}
                      reloadOptions={false}
                      dropdownSelectStyle={{ width: '238px' }}
                      validate={() =>
                        events.form.validate('exit_gate_fleet_system_route_id')
                      }
                      onSelect={(name, id, value) => setRouteOut(id, value)}
                    />
                  )}
                </FormElement>
              </FormListItem>
            </React.Fragment>
          )}
          {useTrackerFlg && (
            <FormListItem label='不在時連絡先'>
              <GatePassageTrackerTelHistoryDropdown
                value={values.sub_tel}
                readOnly={viewOnlyFlag}
                handleOnChange={events.form.set}
                error={errors.sub_tel}
                validate={events.form.validate}
                fieldTreeId={values.field_tree_id}
                column='sub_tel'
                set={events.form.set}
                resetKeys={[values.field_tree_id]}
                inputClassName='input-tel'
                isOptional={true}
              />
            </FormListItem>
          )}
          <FormListItem
            label='ゲート'
            isUseItemIcon={useConstructionSiteCodeFlg}
            itemIconLabel='連携項目'
            required={true}
          >
            <GateDropdown
              value={values.gate_id}
              name={
                _.has(pulldownName, 'gate_name') ? pulldownName.gate_name : null
              }
              error={errors.gate_id}
              readOnly={viewOnlyFlag}
              set={events.form.set}
              validate={events.form.validate}
              isEdit={isEdit}
              isFormListDefault={true}
              gateFleetStatus={values.gate_fleet_status}
            />
          </FormListItem>
          <FormListItem label='ステータス' required={true}>
            <FormElement>
              <select
                className='form-list__select--short'
                value={values.status_code}
                disabled={viewOnlyFlag}
                onChange={e => events.form.set('status_code', e.target.value)}
              >
                {_.map(GATE_PASSAGES_STATUS_CODE, statusCode => {
                  if (statusCode.id > 0) {
                    return (
                      <option key={statusCode.id} value={statusCode.id}>
                        {statusCode.name}
                      </option>
                    );
                  }
                })}
              </select>
              <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
            </FormElement>
          </FormListItem>
          <FormListItem
            label='車輌名'
            isUseItemIcon={useConstructionSiteCodeFlg}
            itemIconLabel='連携項目'
          >
            <GatePassageLatestRegistrationDropdown
              value={values.truck_name}
              error={errors.truck_name}
              fieldTreeId={values.field_tree_id}
              maxLength={255}
              column='truck_name'
              readOnly={viewOnlyFlag}
              set={events.form.set}
              validate={events.form.validate}
              isFormListDefault={true}
              isOptional={true}
            />
          </FormListItem>
          <FormListItem
            label='台数'
            isUseItemIcon={useConstructionSiteCodeFlg}
            itemIconLabel='連携項目'
            required={true}
          >
            <FormElement>
              <select
                className={`form-list__select--short${
                  viewOnlyFlag ? ' gate_passage-approved' : ''
                }`}
                value={values.truck_count}
                disabled={viewOnlyFlag}
                onChange={e => events.form.set('truck_count', e.target.value)}
              >
                {_.map(systemTruckCount, track => (
                  <option key={track.id} value={track.id}>
                    {track.name}
                  </option>
                ))}
              </select>
              <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              {useConstructionSiteCodeFlg && (
                <div className='form-list__element--btn'>
                  <button
                    id='form-dropdown-btn'
                    className='btn-fixedsize--sub'
                    onClick={() => handleVehicleNumberDialog(viewOnlyFlag)}
                  >
                    車両編集
                  </button>
                </div>
              )}
            </FormElement>
          </FormListItem>
          <FormListItem
            label='荷種'
            isUseItemIcon={useConstructionSiteCodeFlg}
            itemIconLabel='連携項目'
            required={true}
          >
            <FormElement
              validate={errors.luggage}
              info={
                hasLuggageTypeRadio && messageUtility.getMessage('I-001-512')
              }
            >
              <div className='form-container__wrapper'>
                {hasLuggageTypeRadio && (
                  <div className='form-element__list'>
                    {_.map(LUGGAGE_TYPES, item => (
                      <div className='form-list-radio__item' key={item.id}>
                        <label className='radio'>
                          <input
                            type='radio'
                            id={`form-radio-use-construction-site-code-flag-${item.id}`}
                            value={item.value}
                            name='construction-site-code-flag'
                            checked={
                              item.value
                                ? _.isEqual(values.luggage, item.value)
                                : isCheckedLuggageTypeOther(values.luggage)
                            }
                            onChange={() =>
                              events.form.setLuggageType(item.value)
                            }
                          />
                          <RadioButtonIcon className='icon--2x' />
                          <span>{item.name}</span>
                        </label>
                      </div>
                    ))}
                  </div>
                )}
                <div className='form-container__item-input'>
                  <GatePassageLatestRegistrationDropdown
                    value={values.luggage}
                    fieldTreeId={values.field_tree_id}
                    maxLength={255}
                    column='luggage'
                    readOnly={viewOnlyFlag}
                    set={(name, value, id) => events.form.set(name, value, id)}
                    validate={events.form.validate}
                    isFormListDefault={true}
                    useConstructionSiteCodeFlg={useConstructionSiteCodeFlg}
                    isDisabledInput={
                      hasLuggageTypeRadio &&
                      !isCheckedLuggageTypeOther(values.luggage)
                    }
                    inputClassName={
                      hasLuggageTypeRadio && 'gate-passages-luggage-input'
                    }
                  />
                </div>
              </div>
            </FormElement>
          </FormListItem>
          {useTrackerFlg && (
            <FormListItem label='運行グループ'>
              <FormElement>
                <DropdownSelector
                  label={'運行グループを選択'}
                  selectorName='transportation_group_id'
                  api={params =>
                    GatePassageService.getListTransportationGroups(
                      fieldId,
                      params
                    )
                  }
                  apiParams={{
                    field_id: fieldId,
                    limit: REQUEST_PARAMS.parentLimit,
                    company_id: SessionStorageService.getCompanyId(),
                  }}
                  selectedValues={
                    _.isNull(values.transportation_group_id)
                      ? ''
                      : String(values.transportation_group_id)
                  }
                  selectedName={pulldownName.transportation_group_name}
                  keyName='name'
                  valueName='id'
                  apiBindDataKey={'transportation_groups'}
                  onSelect={events.form.set}
                  multiple={false}
                  isOptional={true}
                  dropdownSelectStyle={{ width: '238px' }}
                  strictEqual={true}
                  readOnly={viewOnlyFlag}
                  apiSearchKey='name'
                />
                {!viewOnlyFlag && !isEdit && (
                  <div className='form-list__element--btn'>
                    <button
                      id='gate-transportation-group-edit'
                      className='btn--small--stay'
                      onClick={() => {
                        const companyId = SessionStorageService.getCompanyId();
                        window.location.replace(
                          `/tracker/transportationGroup?__currentFieldId=${fieldId}&__currentCompanyId=${companyId}`
                        );
                      }}
                    >
                      編集
                    </button>
                  </div>
                )}
              </FormElement>
            </FormListItem>
          )}
          <FormListItem
            label='時間'
            isUseItemIcon={useConstructionSiteCodeFlg}
            itemIconLabel='連携項目'
            required={true}
          >
            <FormElement
              className={`form-list__element ${
                errors.passage_start_time || errors.passage_end_time
                  ? 'form-list__element--error'
                  : ''
              }`}
            >
              <div htmlFor='' className='input-date-range'>
                <select
                  name='passage_start_time'
                  disabled={viewOnlyFlag || isAcceptWithFutral}
                  id='gate-passages-passage_start_time'
                  value={values.passage_start_time}
                  onChange={e => events.form.setTime(e, 'passage_end_time')}
                  onBlur={e => events.form.validate(e.target.name)}
                >
                  {!isTimeInsideLimit(
                    values.passage_start_time,
                    workStartTime,
                    workEndTime
                  ) && (
                    <option disabled hidden value={values.passage_start_time}>
                      {values.passage_start_time.length > 0
                        ? formatHourMin(values.passage_start_time)
                        : `---`}
                    </option>
                  )}
                  {startTime()}
                </select>
                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
                <span className='input-date-range__bar'>～</span>
                <select
                  name='passage_end_time'
                  disabled={viewOnlyFlag || isAcceptWithFutral}
                  id='gate-passages-passage_end_time'
                  value={values.passage_end_time}
                  onChange={e => events.form.setTime(e, 'passage_start_time')}
                  onBlur={e => events.form.validate(e.target.name)}
                >
                  {!isTimeInsideLimit(
                    values.passage_end_time,
                    workStartTime,
                    workEndTime
                  ) && (
                    <option disabled hidden value={values.passage_end_time}>
                      {values.passage_end_time.length > 0
                        ? formatHourMin(values.passage_end_time)
                        : `---`}
                    </option>
                  )}
                  {endTime()}
                </select>
                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              </div>
              <Validation
                validate={errors.passage_start_time || errors.passage_end_time}
              />
              {((viewOnlyFlag && isSpotFlag(values.spot_flag)) ||
                !viewOnlyFlag) &&
              !isAcceptWithFutral ? (
                <div className='form-container__item'>
                  <label htmlFor='check2' className='checkbox'>
                    <input
                      type='checkbox'
                      id='check2'
                      name='spot_flag'
                      disabled={viewOnlyFlag}
                      checked={isSpotFlag(values.spot_flag)}
                      onChange={() =>
                        events.form.setSpotStatus(isSpotFlag(values.spot_flag))
                      }
                    />
                    {!viewOnlyFlag && (
                      <i className='i-square i-3x' aria-hidden='true' />
                    )}
                    <span className='form-list__item-text'>スポット作業</span>
                  </label>
                </div>
              ) : (
                isSpotFlag(values.spot_flag) && (
                  <div className='form-container__item'>
                    <label htmlFor='check2' className='checkbox'>
                      <span className='form-list__item-text'>スポット作業</span>
                    </label>
                  </div>
                )
              )}
              {values.spot_flag == SPOT_STATUS.spot.id && (
                <div htmlFor='' className='input-date-range__radio show'>
                  <select
                    className='form-list__select--short'
                    value={values.spot_time}
                    disabled={viewOnlyFlag || isAcceptWithFutral}
                    onChange={e => events.form.set('spot_time', e.target.value)}
                  >
                    {_.map(SPOT_TIMES, spotTime => {
                      return (
                        <option key={spotTime.id} value={spotTime.id}>
                          {spotTime.name}
                        </option>
                      );
                    })}
                  </select>
                  <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
                </div>
              )}
            </FormElement>
          </FormListItem>
          <FormListItem
            label='元請担当者'
            isUseItemIcon={useConstructionSiteCodeFlg}
            itemIconLabel='連携項目'
            required={useConstructionSiteCodeFlg}
          >
            <FieldContractorUserDropdown
              value={values.manager_user_id}
              name={
                _.has(pulldownName, 'manager_user_name')
                  ? pulldownName.manager_user_name
                  : null
              }
              fieldTreeId={values.field_tree_id}
              jobId={values.job_id}
              readOnly={viewOnlyFlag}
              set={events.form.set}
              isFormListDefault={true}
              dateToValue={
                isEdit ? values.passage_date : values.passage_date_to
              }
              isFilterByDateTo={true}
              error={errors.manager_user_id}
              validate={() => events.form.validate('manager_user_id')}
              useConstructionSiteCodeFlg={useConstructionSiteCodeFlg}
            />
          </FormListItem>
          <FormListItem
            label='使用揚重機'
            className={`form-list__item ${
              values.crane_id ? 'form-list__item--open' : ''
            }`}
          >
            <CraneDropdown
              value={values.crane_id}
              name={
                _.has(pulldownName, 'crane_name')
                  ? pulldownName.crane_name
                  : null
              }
              error={errors.crane_id}
              readOnly={viewOnlyFlag}
              set={events.form.crane}
              resetFlag={true}
              column='crane_use_id'
              isFormListDefault={true}
              isOptional={true}
            />
          </FormListItem>
          <CraneUseField
            values={values}
            events={events}
            errors={errors}
            startTime={startTime}
            endTime={endTime}
            viewOnlyFlag={viewOnlyFlag}
          />
          <FormListItem
            label={
              useConstructionSiteCodeFlg ? '代表連絡先 (元請)' : '代表連絡先'
            }
            isUseItemIcon={useConstructionSiteCodeFlg}
            itemIconLabel='連携項目'
            required={useConstructionSiteCodeFlg}
          >
            <Tel
              value={values.tel}
              readOnly={viewOnlyFlag}
              handleOnChange={events.form.set}
              setKey='tel'
              error={errors.tel}
              validate={() => events.form.validate('tel')}
            />
          </FormListItem>
          <FormListItem label='運転者名'>
            <GatePassageLatestRegistrationDropdown
              value={values.drivers_name}
              error={errors.drivers_name}
              fieldTreeId={values.field_tree_id}
              maxLength={255}
              column='drivers_name'
              readOnly={viewOnlyFlag}
              set={events.form.set}
              validate={events.form.validate}
              isFormListDefault={true}
              isOptional={true}
            />
          </FormListItem>
          <FormListItem label='運用会社'>
            <FormElement
              validate={
                errors.control_company_name && errors.control_company_name
              }
            >
              {viewOnlyFlag ? (
                <div>{values.control_company_name}</div>
              ) : (
                <input
                  type='text'
                  disabled={viewOnlyFlag}
                  value={values.control_company_name}
                  maxLength={255}
                  onChange={e =>
                    events.form.set('control_company_name', e.target.value)
                  }
                />
              )}
            </FormElement>
          </FormListItem>
          <FormListItem
            label='備考'
            isUseItemIcon={useConstructionSiteCodeFlg}
            itemIconLabel='連携項目'
          >
            <FormElement validate={errors.memo && errors.memo}>
              {viewOnlyFlag ? (
                <div className='form-list__textare--disable'>{values.memo}</div>
              ) : (
                <textarea
                  value={values.memo}
                  disabled={viewOnlyFlag}
                  maxLength={512}
                  onChange={e => events.form.set('memo', e.target.value)}
                  style={
                    viewOnlyFlag
                      ? {
                          backgroundColor: 'transparent',
                          color: '#E0E0E0',
                          border: 'none',
                        }
                      : {}
                  }
                />
              )}
            </FormElement>
          </FormListItem>
        </FormList>
      </div>
    </div>
  );
};

const isCheckedLuggageTypeOther = (type) => {
  return !type || !_.some(LUGGAGE_TYPES, { value: type });
};

/**
 * 協力会社入力
 * @param isSpot {bool} スポット利用
 * @param values {object} 入力値
 * @param events {function}
 * @param errors {object} バリデーションメッセージ
 * @param viewOnlyFlag {int} 閲覧制限フラグ
 * @param isEdit {bool} 編集フラグ
 * @param useConstructionSiteCodeFlg {bool}
 */
const CompanyField = ({
  isSpot,
  isSpotToggle,
  values,
  events,
  errors,
  viewOnlyFlag,
  isEdit,
  pulldownName,
  useConstructionSiteCodeFlg,
}) => {
  // console.log('GatePassages.jsx', 'CompanyField', pulldownName);

  const roleId = LocalStorageService.getRoleId();

  if (isSpot == SPOT_STATUS.normal.id) {
    return (
      <div>
        <FormListItem
          label='車輌手配業者'
          isUseItemIcon={useConstructionSiteCodeFlg}
          itemIconLabel='連携項目'
          required={true}
          className='form-list__item form-list__item-spot'
        >
          <FieldTreePartnerCompanyDropdown
            value={values.field_tree_id}
            name={
              _.has(pulldownName, 'company_name')
                ? pulldownName.company_name
                : null
            }
            validate={events.form.validate}
            error={errors.field_tree_id}
            readOnly={viewOnlyFlag}
            isEdit={isEdit}
            isSpotToggle={isSpotToggle}
            set={events.form.set}
            otherComponnent={
              isPrimaryCompanyRoleId(roleId) &&
              !viewOnlyFlag && (
                <div className={`form-list__element--btn`}>
                  <button
                    className='btn-fixedsize--sub'
                    onClick={() => events.form.setSpot(SPOT_STATUS.spot.id)}
                  >
                    スポット業者
                  </button>
                </div>
              )
            }
            dateTo={isEdit ? values.passage_date : values.passage_date_to}
            isFormListDefault={true}
          />
        </FormListItem>
        <FormListItem label='職種' required={useConstructionSiteCodeFlg}>
          <FieldTreeJobDropdown
            value={values.job_id}
            name={
              _.has(pulldownName, 'job_name') ? pulldownName.job_name : null
            }
            error={errors.job_id}
            fieldTreeId={values.field_tree_id}
            readOnly={viewOnlyFlag}
            isEdit={isEdit}
            set={events.form.set}
            userValueChangeFlag={values.userValueChangeFlag}
            dateTo={isEdit ? values.passage_date : values.passage_date_to}
            isFormListDefault={true}
            validate={() => events.form.validate('job_id')}
            isOptional={!useConstructionSiteCodeFlg}
          />
        </FormListItem>
        <FormListItem label='職長' required={useConstructionSiteCodeFlg}>
          <FieldTreeUserDropdown
            value={values.foreman_user_id}
            name={
              _.has(pulldownName, 'foreman_user_name')
                ? pulldownName.foreman_user_name
                : null
            }
            error={errors.foreman_user_id}
            fieldTreeId={values.field_tree_id}
            jobId={values.job_id}
            readOnly={viewOnlyFlag}
            isEdit={isEdit}
            set={events.form.set}
            userValueChangeFlag={values.userValueChangeFlag}
            dateTo={isEdit ? values.passage_date : values.passage_date_to}
            isFormListDefault={true}
            validate={() => events.form.validate('foreman_user_id')}
            isOptional={!useConstructionSiteCodeFlg}
          />
        </FormListItem>
      </div>
    );
  } else {
    return null;
  }
};

/**
 * スポット業者入力
 * @param isSpot {bool} スポット利用
 * @param values {object} 入力値
 * @param events {function}
 * @param errors {object} バリデーションメッセージ
 * @param viewOnlyFlag {int} 閲覧制限フラグ
 */
const SpotField = ({
  isSpot,
  values,
  events,
  errors,
  viewOnlyFlag,
  useConstructionSiteCodeFlg,
}) => {
  if (isSpot == SPOT_STATUS.spot.id) {
    return (
      <div>
        <FormListItem
          label='車輌手配業者'
          isUseItemIcon={useConstructionSiteCodeFlg}
          itemIconLabel='連携項目'
          required={true}
        >
          <GatePassageSpotHistoryDropdown
            value={values.spot_company_name}
            error={errors.spot_company_name}
            readOnly={viewOnlyFlag}
            events={events.form.setSpot}
            set={events.form.set}
            validate={events.form.validate}
            isFormListDefault={true}
          />
        </FormListItem>
        <FormListItem label='職種' required={useConstructionSiteCodeFlg}>
          <FormElement validate={errors.spot_foreman_user_job}>
            {viewOnlyFlag ? (
              <div>{values.spot_foreman_user_job}</div>
            ) : (
              <input
                type='text'
                name='spot_foreman_user_job'
                disabled={viewOnlyFlag}
                value={values.spot_foreman_user_job}
                maxLength={255}
                onChange={e => events.form.set(e.target.name, e.target.value)}
                onBlur={e => events.form.validate(e.target.name)}
              />
            )}
          </FormElement>
        </FormListItem>
        <FormListItem label='職長' required={useConstructionSiteCodeFlg}>
          <FormElement validate={errors.spot_foreman_user_name}>
            {viewOnlyFlag ? (
              <div>{values.spot_foreman_user_name}</div>
            ) : (
              <input
                type='text'
                name='spot_foreman_user_name'
                disabled={viewOnlyFlag}
                value={values.spot_foreman_user_name}
                maxLength={255}
                onChange={e => events.form.set(e.target.name, e.target.value)}
                onBlur={e => events.form.validate(e.target.name)}
              />
            )}
          </FormElement>
        </FormListItem>
      </div>
    );
  } else {
    return null;
  }
};

/**
 * 揚重機予定 使用揚重機を選択する表示
 * @param values {object} 入力値
 * @param events {function}
 * @param errors {object} バリデーションメッセージ
 * @param viewOnlyFlag {int} 閲覧制限フラグ
 */
const CraneUseField = ({
  values,
  events,
  errors,
  startTime,
  endTime,
  viewOnlyFlag,
}) => {
  if (values.crane_id) {
    return (
      <React.Fragment>
        <FormListItem
          label='管理会社名'
          className='form-list__item form-list__item--child'
        >
          <FormElement validate={errors.company_name && errors.company_name}>
            <div>{values.company_name}</div>
          </FormElement>
        </FormListItem>
        <FormListItem
          label='オペレーター'
          className='form-list__item form-list__item--child'
        >
          <FormElement validate={errors.operator_name && errors.operator_name}>
            <div>{values.operator_name}</div>
          </FormElement>
        </FormListItem>
        <FormListItem
          label='性能'
          className='form-list__item form-list__item--child'
        >
          <FormElement validate={errors.spec_form && errors.spec_form}>
            <div>{values.spec_form}</div>
          </FormElement>
        </FormListItem>
        <FormListItem
          label='作業内容'
          required={true}
          className='form-list__item form-list__item--child'
        >
          {viewOnlyFlag ? (
            <FormElement>
              <div className='form-list__textare--disable'>
                {values.crane_work_contents}
              </div>
            </FormElement>
          ) : (
            <CraneUseLatestRegistrationDropdown
              value={values.crane_work_contents}
              error={errors.crane_work_contents}
              fieldTreeId={values.field_tree_id}
              column='work_contents'
              readOnly={viewOnlyFlag}
              // 取得元はCraneのwork_contentsだがset、validateはGateで使うのでcrane_work_contentsで行う
              set={(name, value) =>
                events.form.set('crane_work_contents', value)
              }
              validate={() => events.form.validate('crane_work_contents')}
              isTextArea={true}
              maxLength={255}
              info={'※エリアを明記してください。'}
            />
          )}
        </FormListItem>
        <FormListItem
          label='時間'
          required={true}
          className='form-list__item form-list__item--child'
        >
          <FormElement
            className={`form-list__element ${
              errors.use_start_time || errors.use_end_time
                ? 'form-list__element--error'
                : ''
            }`}
          >
            <div htmlFor='' className='input-date-range'>
              <select
                name='use_start_time'
                disabled={viewOnlyFlag}
                id='gate-passages-use_start_time'
                value={values.use_start_time}
                onChange={e => events.form.setTime(e, 'use_end_time')}
                onBlur={e => events.form.validate(e.target.name)}
              >
                <option value=''>---</option>
                {startTime()}
              </select>
              <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              <span className='input-date-range__bar'>～</span>
              <select
                name='use_end_time'
                disabled={viewOnlyFlag}
                id='gate-passages-use_end_time'
                value={values.use_end_time}
                onChange={e => events.form.setTime(e, 'use_start_time')}
                onBlur={e => events.form.validate(e.target.name)}
              >
                <option value=''>---</option>
                {endTime()}
              </select>
              <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
            </div>
            <Validation
              validate={errors.use_start_time || errors.use_end_time}
            />
            {((viewOnlyFlag && values.crane_spot_flag == SPOT_STATUS.spot.id) ||
              !viewOnlyFlag) && (
              <div className='form-container__item'>
                <label className='checkbox' htmlFor='check'>
                  <input
                    type='checkbox'
                    id='check'
                    name='spot_flag'
                    disabled={viewOnlyFlag}
                    checked={values.crane_spot_flag == SPOT_STATUS.spot.id}
                    onChange={() =>
                      events.form.setCraneSpotStatus(
                        values.crane_spot_flag == SPOT_STATUS.spot.id
                      )
                    }
                  />
                  {!viewOnlyFlag && (
                    <i className='i-square i-3x' aria-hidden='true' />
                  )}
                  <span className='form-list__item-text'>スポット作業</span>
                </label>
              </div>
            )}
            {values.crane_spot_flag == SPOT_STATUS.spot.id && (
              <div htmlFor='' className='input-date-range__radio show'>
                <select
                  className='form-list__select--short'
                  value={values.crane_spot_time}
                  disabled={viewOnlyFlag}
                  onChange={e =>
                    events.form.set('crane_spot_time', e.target.value)
                  }
                >
                  {_.map(SPOT_TIMES, spotTime => {
                    return (
                      <option key={spotTime.id} value={spotTime.id}>
                        {spotTime.name}
                      </option>
                    );
                  })}
                </select>
                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              </div>
            )}
          </FormElement>
        </FormListItem>
      </React.Fragment>
    );
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/components/forms/GatePassages.jsx